// extracted by mini-css-extract-plugin
export default {"viewLoaderGeneral":"misc_viewLoaderGeneral__jzQ7u","viewLoaderMultiSelectList":"misc_viewLoaderMultiSelectList__6g9ky"};